/**
 * 공개 콘텐츠 접속 비콘 — 블로그 게시글 진입·ac-datacenter 접속 시 1회 호출.
 * 무인증·fire-and-forget(실패 무시). 백엔드가 (source, key, 일자, lang)별 누적.
 * 서버측 사용량(ac-datacenter 검색 등)은 백엔드에서 직접 계측하므로 여기선 '접속'만.
 *
 * lang: 현재 URL 이 /en/… 이면 'en'(외국어 페이지), 아니면 'ko'(한국어 페이지).
 * 가입 전환 귀속: 열람할 때마다 'h_src' 쿠키(source|lang|key)를 심어(마지막 열람 덮어씀),
 *   이후 가입/소셜로그인 콜백에서 백엔드가 읽어 신규 회원의 유입출처로 저장한다.
 */
import { api } from './api'

/** 현재 경로가 /en 접두사면 'en', 아니면 'ko' */
export function currentLang(): 'ko' | 'en' {
  try {
    const p = window.location.pathname
    return p === '/en' || p.startsWith('/en/') ? 'en' : 'ko'
  } catch {
    return 'ko'
  }
}

// 가입 전환 귀속 쿠키 — 백엔드 app/pubmetrics/router.py ATTR_COOKIE 와 동일.
const ATTR_COOKIE = 'h_src'
const ATTR_MAX_AGE = 60 * 60 * 24 * 30 // 30일

function setAttributionCookie(source: string, lang: string, key: string): void {
  try {
    // key 에는 '|' 가 없다(슬러그/‘visit’). 안전하게 인코딩.
    const val = `${source}|${lang}|${encodeURIComponent(key).slice(0, 200)}`
    const secure = window.location.protocol === 'https:' ? '; Secure' : ''
    document.cookie = `${ATTR_COOKIE}=${val}; Path=/; Max-Age=${ATTR_MAX_AGE}; SameSite=Lax${secure}`
  } catch {
    /* noop */
  }
}

export function trackView(source: 'blog' | 'ac-datacenter' | 'insurance-refund', key: string): void {
  const lang = currentLang()
  const safeKey = (key || '-').slice(0, 200)
  try {
    void api.post('/metrics/view', { source, key: safeKey, lang }).catch(() => {})
  } catch {
    /* noop */
  }
  setAttributionCookie(source, lang, safeKey)
}
